/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Order_Confirmation_Recipient_InvalidInputs */

const en_error_order_confirmation_recipient_invalid = /** @type {(inputs: Error_Order_Confirmation_Recipient_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The address cannot be added as it is:`)
};

/**
* | output |
* | --- |
* | "The address cannot be added as it is:" |
*
* @param {Error_Order_Confirmation_Recipient_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_order_confirmation_recipient_invalid = /** @type {((inputs?: Error_Order_Confirmation_Recipient_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Order_Confirmation_Recipient_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_order_confirmation_recipient_invalid(inputs)
});